import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { doFormate, ellipseText, isEmpty } from '../../common/Common'
import I18n from '../../common/I18n'


const HawbMawbNo = ({ record }) => {
  const hasMawb = !isEmpty(record.mawb) 
  const hasHawb = !isEmpty(record.hawb)
  return (
    <Fragment>
      {(hasMawb || hasHawb) && (
        <Fragment>
          ({' '}
          {hasMawb && (
            <Fragment>
              {I18n.t('general.mawb')} : {ellipseText (doFormate(record.mawb), 15, true)}
            </Fragment>
          )}
          {hasHawb && (
            <Fragment>
              {' '}
              {hasMawb && <span>&nbsp;,&nbsp;</span>}
              {I18n.t('general.hawb')} : {ellipseText (doFormate(record.hawb), 15, true)}
            </Fragment>
          )}{' '}
          )
        </Fragment>
      )}
    </Fragment>
  )
}

HawbMawbNo.propTypes = {
  record: PropTypes.shape.isRequired,
}

export default HawbMawbNo
